import React from 'react'
import HeaderSix from '../components/header/HeaderSix'
import FooterSix from '../components/footer/FooterSix'
import AboutPageBreadcrumb from '../components/techdigit/about/AboutPageBreadcrumb'
import AboutPageHero from '../components/techdigit/about/AboutPageHero'
import AboutOriginStory from '../components/techdigit/about/AboutOriginStory'
import AboutPhilosophyStrip from '../components/techdigit/about/AboutPhilosophyStrip'
import AboutLessonsLearned from '../components/techdigit/about/AboutLessonsLearned'
import AboutFounderPrivacy from '../components/techdigit/about/AboutFounderPrivacy'
import AboutPageFaq from '../components/techdigit/about/AboutPageFaq'
import AboutClosingCta from '../components/techdigit/about/AboutClosingCta'
import ScrollAnimation from '../components/motion/ScrollAnimation'

function AboutUs() {
    return (
        <div className="index-six about-us-page">
            <HeaderSix />
            <main>
                <ScrollAnimation direction="fade" delay={0.03} duration={0.38}>
                    <AboutPageBreadcrumb />
                </ScrollAnimation>
                <ScrollAnimation direction="up" delay={0.06} duration={0.5}>
                    <AboutPageHero />
                </ScrollAnimation>
                <ScrollAnimation direction="left" delay={0.08} duration={0.52}>
                    <AboutOriginStory />
                </ScrollAnimation>
                <ScrollAnimation direction="right" delay={0.08} duration={0.52}>
                    <AboutPhilosophyStrip />
                </ScrollAnimation>
                <ScrollAnimation direction="up" delay={0.06} duration={0.48}>
                    <AboutLessonsLearned />
                </ScrollAnimation>
                <ScrollAnimation direction="up" delay={0.08} duration={0.48}>
                    <AboutFounderPrivacy />
                </ScrollAnimation>
                <ScrollAnimation direction="fade" delay={0.04} duration={0.42}>
                    <AboutPageFaq />
                </ScrollAnimation>
                <ScrollAnimation direction="down" delay={0.05} duration={0.44}>
                    <AboutClosingCta />
                </ScrollAnimation>
            </main>
            <FooterSix />
        </div>
    )
}

export default AboutUs
